import { render, staticRenderFns } from "./UserSuggestionForm.vue?vue&type=template&id=292abfd8"
import script from "./UserSuggestionForm.vue?vue&type=script&lang=js"
export * from "./UserSuggestionForm.vue?vue&type=script&lang=js"
import style0 from "./UserSuggestionForm.vue?vue&type=style&index=0&id=292abfd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports